import { Service } from '../Service';
export default class EventService extends Service {
    constructor(axios) {
        super(axios);
    }
}
